import { render, staticRenderFns } from "./modal-callback-fixed.vue?vue&type=template&id=58de0f36&"
import script from "./modal-callback-fixed.vue?vue&type=script&lang=js&"
export * from "./modal-callback-fixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports